export const errorMessages = {
  GENERIC_DECLINE: 'Payment failed, please try again later',
  INSUFFICIENT_FUNDS: 'Insuficient funds',
  INVALID_ACCOUNT_NUMBER: 'Invalid account number',
  ADDRESS_VERIFICATION_FAILED_RISK_RULES: 'Could not verify address',
  CVV_FAILED_RISK_RULES: 'Could not verify CVV',
};
